$(document).ready(function () {
    // CBU, "Nog in overleg" and "Invoeren" (nothing chosen yet) don't carry a numeric amount, so
    // the amount field for that row is disabled while one of those is selected.
    const PRICE_AGREEMENT_TYPES_WITHOUT_AMOUNT = ['', 'cbu', 'in_discussion'];

    function toggleAmountField($priceAgreementSelect) {
        const $amountInput = $priceAgreementSelect.closest('tr').find("input[name='amount']");
        const disabled = PRICE_AGREEMENT_TYPES_WITHOUT_AMOUNT.includes($priceAgreementSelect.val());
        $amountInput.prop('disabled', disabled);
    }

    // A locked year (see PriceAgreement::isLocked()) stays fully editable, it just warns first —
    // window.confirm is overridden by compass (resources/js/components/confirm.js) to show a
    // modal instead of blocking synchronously, so the actual save happens in the accept callback.
    function withLockConfirmation(el, proceed) {
        if ($(el).data('locked') != '1') {
            proceed();
            return;
        }

        confirm('Dit jaar is afgesloten. Toch aanpassen?', proceed);
    }

    $("select[name='price_agreement']").each(function () {
        toggleAmountField($(this));
    });

    $("input[name='time_estimate_in_minutes']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        withLockConfirmation(this, () => updateField(this, 'time_estimate_in_minutes', priceAgreementId));
    });

    $("input[name='amount']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        withLockConfirmation(this, () => {
            // remove euro sign from input
            this.value = this.value.replace('€ ', '');
            let result = formatEUCurrency($(this));
            updateField(this, 'amount', priceAgreementId);
            // readd euro sign to input
            if (!this.value.includes('€')) {
                this.value = '€ ' + this.value;
            }
        });
    });

    $("select[name='price_agreement']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        withLockConfirmation(this, () => {
            toggleAmountField($(this));
            updateField(this, 'price_agreement', priceAgreementId);
        });
    });

    $("select[name='price_agreement_deposit']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        withLockConfirmation(this, () => updateField(this, 'price_agreement_deposit', priceAgreementId));
    });

    $("select[name='invoicing_type']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        withLockConfirmation(this, () => updateField(this, 'invoicing_type', priceAgreementId));
    });

    $("textarea[name='remarks']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        withLockConfirmation(this, () => updateField(this, 'remarks', priceAgreementId));
    });

    function updateField(el, fieldName, priceAgreementId) {
        // Can occur when certain events collide
        if (el.value === undefined) {
            return;
        }
        // Save the field if success message is returned. else show error message under field.
        $.post('/api/price-agreements/'+priceAgreementId+'/update-field', {
            [fieldName]: el.value
        }).done(function (data) {
            // if data.success === false, show error message under field
            try {
                // make el red if error
                console.log(data);

                if (data.success === false) {
                    $(el).removeClass('is-invalid');
                    $(el).next('.invalid-feedback').remove();
                    $(el).addClass('is-invalid');
                    $(el).after('<div class="invalid-feedback">'+ data.message +'</div>');
                } else {
                    $(el).removeClass('is-invalid');
                    $(el).next('.invalid-feedback').remove();
                }
            } catch (e) {
                console.log(e);
            }
        });

    }

    function dotCount(number) {
        const numberAsString = number.toString();
        if (numberAsString.includes('.')) {
            return numberAsString.split('.')[1].length;
        }
        return 0;
    }

    function formatEUCurrency(input) {
        let input_val = input.val();
        let start_char = input_val.charAt(0);

        // don't validate empty input
        if (input_val === "") {
            return;
        }

        if (dotCount(input_val) > 2) {
            input_val = input_val.replace('.', "");
        }

        if (dotCount(input_val) <= 2) {
            input_val = input_val.replace('.', ",");
        }
        input_val = input_val.replace(',', ".");


        let currencyVal = new Intl.NumberFormat('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(input_val);

        // send updated string to input
        if (start_char === '-') {
            currencyVal = '-' + input_val;
        }

        if (currencyVal !== 'NaN') {
            input.val(currencyVal);
        }

        return currencyVal;
    }
});
